import { render, staticRenderFns } from "./estado-solicitud.vue?vue&type=template&id=235ab596&scoped=true&"
import script from "./estado-solicitud.component.ts?vue&type=script&lang=ts&"
export * from "./estado-solicitud.component.ts?vue&type=script&lang=ts&"
import style0 from "./estado-solicitud.vue?vue&type=style&index=0&id=235ab596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ab596",
  null
  
)

export default component.exports